import type { Business } from '@rewardopl/types';
import type { Fields } from '../../../../../../types';

const fields: Fields<Business> = [
  { name: 'tin' },
  {
    name: 'billing_name',
    label: 'Business name',
  },
  {
    name: 'billing_address',
    type: 'address',
  },
];

export default fields;
